import EdaTypeDto from 'app/admin/eda/dto/EdaTypeDto';
import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import SensorValueDto from './SensorValueDto';

export default class SensorTypeDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.manufacturer = null;
		/** @type {string} */
		this.modelId = null;
		/** @type {EdaTypeDto[]} */
		this.edaTypeList = null;
		/** @type {number} */
		this.externalId = null;
		/** @type {SensorValueDto[]} */
		this.valueList = null;
	}

	/**
	 * @typedef {Object} _SensorTypeDtoProps
	 * @property {string} manufacturer
	 * @property {string} modelId
	 * @property {EdaTypeDto[]} edaTypeList
	 * @property {number} externalId
	 * @property {SensorValueDto[]} valueList
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _SensorTypeDtoProps} SensorTypeDtoProps
	 */
	/**
	 *
	 * @param {SensorTypeDtoProps} props
	 * @returns {SensorTypeDto}
	 */
	setup(props) {
		super.setup(props);
		this.manufacturer = props.manufacturer;
		this.modelId = props.modelId;
		this.edaTypeList = _.isArray(props.edaTypeList) ? props.edaTypeList.map(d => new EdaTypeDto().setup(d)) : [];
		this.externalId = props.externalId;
		this.valueList = _.isArray(props.valueList) ? props.valueList.map(d => new SensorValueDto().setup(d)) : [];
		return this;
	}
}
